import { PublishRulesCategoriesEnum } from 'PublishRulesPackage/MainModule/enums/publishRulesCategoriesEnum';

import { apiDelete, apiGet, apiPost } from '../../MainModule/common/apiTools';
import { getServiceBaseURL } from '../../MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from '../../MainModule/enums/APIServiceEnum';
import { IKnmHistoryItem } from '../../KnmModule/interfaces/IKnmHistoryItem';
import { IPublishRules } from '../interfaces/IPublishRules';

export async function fetchPublishRulesByCode(code: string): Promise<IPublishRules> {
  return apiGet<IPublishRules>(`${getServiceBaseURL(APIServiceEnum.LK_SERVICE)}/publications/settings/${code}`);
}

export async function createOrUpdatePublishRulesByCode(
  code: string | number,
  body: IPublishRules,
): Promise<IPublishRules> {
  return apiPost<IPublishRules>({
    url: `${getServiceBaseURL(APIServiceEnum.LK_SERVICE)}/publications/settings/${code}`,
    body,
  });
}

export async function deletePublishRulesByCode(code: string): Promise<void> {
  return apiDelete<void>(`${getServiceBaseURL(APIServiceEnum.LK_SERVICE)}/publications/settings/${code}`);
}

export async function fetchPublishRulesHistoryByCode(code: string, approveType?: string): Promise<IKnmHistoryItem[]> {
  return apiGet<IKnmHistoryItem[]>(
    `${getServiceBaseURL(APIServiceEnum.LK_SERVICE)}/publications/settings/${code}/history${
      approveType ? `?approveRequiredType=${approveType}` : ''
    }`,
  );
}

export async function fetchPublishRulesHaveSavedSettingsCategories(): Promise<PublishRulesCategoriesEnum[]> {
  return apiGet<PublishRulesCategoriesEnum[]>(
    `${getServiceBaseURL(APIServiceEnum.LK_SERVICE)}/publications/settings/categories`,
  );
}
